<template>
  <div class="container" v-if="!isDismissed" style="margin-top: 1%">
    <div class="alert-banner" :class="bannerClass">
      <div class="alert-content">
        <i :class="iconClass"></i>
        <span v-html="message"></span>
      </div>

      <!-- Dynamic action area based on status -->
      <div class="action-area">
        <!-- For 'pending' status -->
        <div v-if="status === 'pending'" class="pending-info">
          <button
            class="alert-button alert-button-subtle"
            @click="dismissAlert"
          >
            Dismiss
          </button>
        </div>

        <!-- For 'approved' status -->
        <!-- <div v-else-if="status === 'approved'" class="approved-actions">
          <button
            class="alert-button alert-button-subtle"
            @click="dismissAlert"
          >
            Dismiss
          </button>
        </div> -->

        <!-- For 'not_submitted' or 'rejected' status -->
        <button
          v-else-if="status === 'rejected' || status === 'not_submitted'"
          class="alert-button"
          :class="{ 'alert-button-warning': status === 'rejected' }"
          @click="navigateToRoute"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VerificationAlert",
  props: {
    message: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: "Verification Steps",
    },
    buttonRoute: {
      type: String,
      default: "/pre-verification-form",
    },
    status: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      isDismissed: false,
    };
  },
  created: function () {
    // Check if alert was previously dismissed
    try {
      // const dismissed = localStorage.getItem(
      //   "verification_alert_dismissed_" + this.status
      // );
      // this.isDismissed = dismissed === "true";
    } catch (error) {
      console.error("Error reading from localStorage:", error);
    }
  },
  computed: {
    bannerClass: function () {
      // Different background colors for different statuses
      if (this.status === "approved") {
        return "alert-banner-success";
      } else if (this.status === "rejected") {
        return "alert-banner-warning";
      } else if (this.status === "pending") {
        return "alert-banner-info";
      } else {
        return ""; // default yellow for not_submitted
      }
    },
    iconClass: function () {
      // Different icons for different statuses
      var baseClass = "mr-2 text-xl ";

      if (this.status === "approved") {
        return baseClass + "bi bi-check-circle-fill";
      } else if (this.status === "rejected") {
        return baseClass + "bi bi-exclamation-triangle-fill";
      } else if (this.status === "pending") {
        return baseClass + "bi bi-hourglass-split";
      } else {
        return baseClass + "bi bi-info-circle-fill";
      }
    },
  },
  methods: {
    dismissAlert: function () {
      this.isDismissed = true;
      this.$emit("dismiss", this.status);

      // Store dismissal status in localStorage for ALL statuses, not just pending
      try {
        // localStorage.setItem(
        //   "verification_alert_dismissed_" + this.status,
        //   "true"
        // );
      } catch (error) {
        console.error("Error saving alert preference:", error);
      }
    },

    navigateToRoute: function () {
      // Check if we're already on the target route
      const currentPath = this.$route.path + (this.$route.hash || "");
      if (currentPath === this.buttonRoute) {
        return; // Don't navigate if already on the same route
      }

      // Force navigation for rejected status
      if (this.status === "rejected") {
        // Use window.location for rejected status to ensure it works
        window.location.href = this.buttonRoute;
        return;
      }

      // Regular navigation for other statuses
      this.$router.push(this.buttonRoute).catch((err) => {
        // Ignore navigation duplicated errors
        if (err.name !== "NavigationDuplicated") {
          // Fallback to window.location if router fails
          window.location.href = this.buttonRoute;
        }
      });
    },

    goToProfile: function () {
      const targetRoute = "/user/activities#profile";
      const currentPath = this.$route.path + (this.$route.hash || "");

      if (currentPath === targetRoute) {
        return; // Don't navigate if already on the same route
      }

      this.$router.push(targetRoute).catch((err) => {
        // Ignore navigation duplicated errors
        if (err.name !== "NavigationDuplicated") {
          console.error("Navigation error:", err);
        }
      });
    },
  },
};
</script>
